import { Capacitor } from "@capacitor/core";

// Garden Premium and the credit bundles are digital content consumed inside the
// app, so on iOS they would have to be sold through Apple's in-app purchase.
// They're sold through Stripe on the web instead, and the /upgrade page used to
// tell native users to "open this page in a browser to upgrade". Guideline
// 3.1.3(a) prohibits directing users to an external purchase mechanism for
// digital content, and pointing a reviewer at a website to pay is the version
// of it they actually reject.
//
// So on iOS we hide the paywall CTAs and the purchase surface entirely: no
// upsell, no price, and no instruction to buy elsewhere. Android and web are
// unaffected. Delete this gate once the premium tier is either sold through
// StoreKit or dropped from iOS.
export function useHidePaidUpgradesOnIos(): boolean {
  return Capacitor.isNativePlatform() && Capacitor.getPlatform() === "ios";
}
